// @ts-ignore
import { jarallax, jarallaxVideo } from "jarallax";

export class Parallax {
  target: Element;

  constructor(target) {
    this.target = target
    this.init();
  }

  init() {
    jarallax(this.target, {
      speed: 0.5,
    });
  }

}
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('[data-parallax]').forEach((item: Element) => {
    new Parallax(item);
  });
});
